import { IUnderwriterProfileSummaryData } from 'types/administration/pricing/IUnderWriterProfileSummary';
import { identity } from 'lodash';

//eventually, we will have a BE that can store UnderwriterProfiles by ID.
// For now, a profile is uniquely selected by state, underwriter, and zone.
// This function is a temporary band-aid.
export const underwriterProfileURLGenerator = ({ state, underwriter, zone }: Partial<IUnderwriterProfileSummaryData>) =>
  [state, underwriter, zone].filter(identity).join('/');
